module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 482
// module chunks = 0